import { render, staticRenderFns } from "./TableColumnPixelStatus.vue?vue&type=template&id=ccb32c1c&scoped=true&"
import script from "./TableColumnPixelStatus.vue?vue&type=script&lang=js&"
export * from "./TableColumnPixelStatus.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnPixelStatus.vue?vue&type=style&index=0&id=ccb32c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb32c1c",
  null
  
)

export default component.exports